// SignUp.jsx
import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import WithTracker from './../../../../containers/App/WithTracker';
import { connect } from 'react-redux';
import queryString from 'query-string';
import Auth0Lock from 'auth0-lock';

import CheckIcon from 'mdi-react/CheckCircleOutlineIcon';
import CircleIcon from 'mdi-react/CheckboxBlankCircleOutlineIcon';
import ChangeIcon from 'mdi-react/RotateLeftIcon';

import { setPlan } from '../../../../redux/actions/planActions';
import { subscriptionPlans, appFeatures } from './../../payment/plans.js';

import TopBar from './../../TopBar';
import Footer from './../../Footer';
import { _formatNumber } from '../../../helpers/utils';
import { Row, Col, Badge } from 'reactstrap';

const apiUrl = process.env.API_ROOT + '/buyerslist/';

class SignUp extends Component {
  constructor(props){
	super(props);
	this._containerId = 'auth0-embedded-signup'; // STRING id (required by Lock)
	this._lockInited = false;
	this.lock = null;
	this.state = {
	  coupon: false
	};
	this._validateCoupon = this._validateCoupon.bind(this);
  }

  componentDidMount(){
	// Keep your plan logic
	var dispatch = this.props.dispatch;
	var location = this.props.location;
	var urlState = queryString.parse(location.search);
	var plan = urlState && urlState.plan && subscriptionPlans.filter(function(p){ return p.id === urlState.plan; }).length > 0 ? urlState.plan : false;

	if (!plan && typeof localStorage !== 'undefined' && localStorage.getItem('mpnd-plan')) {
	  var planId = localStorage.getItem('mpnd-plan');
	  var ok = subscriptionPlans.filter(function(p){ return p.id === planId; }).length > 0;
	  plan = ok ? planId : false;
	}
	dispatch(setPlan(plan));

	// Store coupon from URL param so it survives the Auth0 redirect
	var couponCode = urlState && urlState.coupon ? urlState.coupon : '';
	if (couponCode) {
	  sessionStorage.setItem('post_auth_coupon', couponCode);
	  // Validate and display coupon
	  this._validateCoupon(couponCode);
	}

	// Initialize after the DOM paints to ensure #auth0-embedded-signup exists
	var self = this;
	window.requestAnimationFrame(function(){ self._initLock(); });
  }

  componentWillUnmount(){
	try { if (this.lock) { this.lock.hide(); } } catch(e){}
  }

  _validateCoupon(couponCode) {
	var self = this;
	fetch(apiUrl + 'stripe/check-coupon', {
	  method: 'post',
	  headers: { 'Content-Type': 'application/json' },
	  body: JSON.stringify({ coupon: couponCode })
	}).then(function (res) {
	  return res.json();
	}).then(function (couponResult) {
	  if (couponResult && couponResult.valid) {
		self.setState({ coupon: couponResult });
	  }
	}).catch(function (err) {
	  console.log('Coupon validation error:', err);
	});
  }

  _initLock(){
	if (this._lockInited) return;

	// Guard: ensure the container div exists
	if (!document.getElementById(this._containerId)) {
	  var self = this;
	  setTimeout(function(){ self._initLock(); }, 50);
	  return;
	}

	var domain      = process.env.REACT_APP_AUTH0_DOMAIN;     // e.g. your-tenant.us.auth0.com
	var clientId    = process.env.REACT_APP_AUTH0_CLIENT_ID;  // SPA client id
	var audience    = process.env.REACT_APP_AUTH0_AUDIENCE;   // API identifier
	var redirectUrl = window.location.origin + '/mpsso/redirect';
	var connection  = 'Username-Password-Authentication';     // DB connection name

	if (!domain || !clientId) {
	  console.error('Missing REACT_APP_AUTH0_DOMAIN or REACT_APP_AUTH0_CLIENT_ID');
	  return;
	}
	
	// determine where to go next after signup
	var planState = this.props.plan;
	var currentPlan = planState && planState.id
	var nextPath = '/payment'; // 👈 your target page
	var planId = currentPlan && currentPlan.id ? currentPlan.id : '';
	var coupon = sessionStorage.getItem('post_auth_coupon') || '';
	var stateObj = { next: nextPath, plan: planId, coupon: coupon, ts: Date.now() };
	var encodedState = btoa(JSON.stringify(stateObj));


	var BRAND_PRIMARY = '#9600BF';
	var BRAND_DARK    = '#1B1039';
	var BRAND_LOGO    = 'https://marketproof.com/svgs/logo.svg';
	
	var options = {
	  container: this._containerId,
	  initialScreen: 'signUp',
	  allowedConnections: [connection],
	  allowSignUp: true,
	  allowLogin: false,
	  autofocus: true,
	  closable: false,
	
	  // 👇 Brand it here
	  theme: {
		primaryColor: BRAND_PRIMARY,
		logo: BRAND_LOGO
		// You can also add "logoAlternativeText" if you want alt text
	  },
	
	  languageDictionary: {
		title: 'Create your Marketproof account',
		emailInputPlaceholder: 'you@company.com',
		passwordInputPlaceholder: 'Create a password',
		signUpTerms:  'By creating an account, you agree to our <br/><a href="https://marketproof.com/terms-of-use" style="color:#9600BF" target="_blank" rel="noreferrer">Terms of Service</a> and <a href="https://marketproof.com/privacy-policy" style="color:#9600BF" target="_blank" rel="noreferrer">Privacy Policy</a>.'

	  },
	
	  additionalSignUpFields: [
		{
		  name: 'given_name',
		  placeholder: 'First name',
		  storage: 'root',
		  validator: function (v) { return v && v.length >= 1; }
		},
		{
		  name: 'family_name',
		  placeholder: 'Last name',
		  storage: 'root',
		  validator: function (v) { return v && v.length >= 1; }
		},
		{ name: 'company', placeholder: 'Company' } // stays in user_metadata
	  ],
	
	  auth: {
		redirectUrl: redirectUrl,
		responseType: 'code',
		params: {
		  scope: 'openid profile email',
		  state: encodedState
		}
	  }
	};

	try {
	  this.lock = new Auth0Lock(clientId, domain, options);
	  this.lock.show();                 // do NOT pass container here
	  this._lockInited = true;
	} catch (e) {
	  var self2 = this;
	  setTimeout(function(){ self2._initLock(); }, 100);
	}
  }

  render(){
	var planState = this.props.plan;
	var currentPlan = planState && planState.id
	  ? subscriptionPlans.filter(function(p){ return p.id === planState.id; })[0]
	  : (subscriptionPlans && subscriptionPlans.length > 0 ? subscriptionPlans[0] : null);
	var coupon = this.state.coupon;

	return (
	  <div className="plan__wrapper share__wrapper">
		<TopBar
		  goTo={currentPlan && !currentPlan.hideChangePlan ? 'plans' : null}
		  buttonText={currentPlan && !currentPlan.hideChangePlan ? 'See Plans' : null}
		/>

		<Row className="login-container signup">
		  <Col lg={6} className="pt-0 signin">
			<div className="desktop-hide text-center ">
			  {currentPlan && currentPlan.freeTrial ?
				<a href="https://marketproof.com/pro" target="_blank" rel="noreferrer">
				  <h3 className="mt-3">Start your 7-day free trial</h3>
				</a> : null}
			  {currentPlan && currentPlan.startAt ? <h5 style={{textTransform:'uppercase'}}>Starting at</h5> : null}
			  {currentPlan ?
				<h3 style={{marginBottom:5}}>
				  {coupon ? (
					<span style={{color:'#9600BF', fontWeight:800}}>
					  <span style={{ textDecoration: 'line-through', color: '#000', fontSize: '0.7em', marginRight: 8 }}>
						${currentPlan.pricePerMonth % 1 != 0 ? currentPlan.pricePerMonth : _formatNumber(currentPlan.pricePerMonth)}
					  </span>
					  ${coupon.percent_off
						? Math.round(currentPlan.pricePerMonth * ((100 - coupon.percent_off) / 100))
						: _formatNumber(currentPlan.pricePerMonth - (coupon.amount_off / 100))} / month
					</span>
				  ) : (
					<span style={{color:'#9600BF', fontWeight:800}}>
					  ${currentPlan.pricePerMonth % 1 != 0 ? currentPlan.pricePerMonth : _formatNumber(currentPlan.pricePerMonth)} / month
					</span>
				  )}
				</h3> : null}
			  {currentPlan ?
				<h6 style={{marginBottom:20}}>
				  <span style={{fontSize:15,fontWeight:600,color:'#363347',textTransform:'uppercase'}}>
					{currentPlan.name} PLAN
				  </span>
				</h6> : null}
			  <div style={{marginTop:5}}>
				{currentPlan && !currentPlan.hideChangePlan ?
				  <Link to="/pricing" style={{color:'#9600BF', textAlign:'right'}}>
					<ChangeIcon size={16} style={{marginTop:-2}} /> Change Plan
				  </Link> : null}
			  </div>
			</div>

			<div className="widget-container" style={{ maxWidth: 420 }}>
			  {/* Embedded Auth0 form mounts here */}
			  <div id={this._containerId} style={{ width:'100%' }} />

			  <div className="signin-toggle">Already have an account? <Link to="/">Sign In</Link></div>
			  
			</div>
		  </Col>

		  <Col lg={6} className="signin-hero-container">
			<div className="signin-hero">
			  {currentPlan && currentPlan.freeTrial ?
				<a href="https://marketproof.com/pro" target="_blank" rel="noreferrer">
				  <h1>Start your 7-day<br/>free trial</h1>
				</a> : null}
			  {currentPlan && currentPlan.startAt ? <h5 style={{textTransform:'uppercase'}}>Starting at</h5> : null}
			  {currentPlan ?
				<h2 style={{marginBottom:0}}>
				  {coupon ? (
					<span style={{color:'#9600BF', fontWeight:800}}>
					  <span style={{ textDecoration: 'line-through', color: '#000', fontSize: '0.7em', marginRight: 8 }}>
						${currentPlan.pricePerMonth % 1 != 0 ? currentPlan.pricePerMonth : _formatNumber(currentPlan.pricePerMonth)}
					  </span>
					  ${coupon.percent_off
						? Math.round(currentPlan.pricePerMonth * ((100 - coupon.percent_off) / 100))
						: _formatNumber(currentPlan.pricePerMonth - (coupon.amount_off / 100))} / month
					</span>
				  ) : (
					<span style={{color:'#9600BF', fontWeight:800}}>
					  ${currentPlan.pricePerMonth % 1 != 0 ? currentPlan.pricePerMonth : _formatNumber(currentPlan.pricePerMonth)} / month
					</span>
				  )}
				</h2> : null}
			  {currentPlan ?
				<h6 style={{marginBottom:20}}>
				  <span style={{fontSize:15,fontWeight:600,color:'#363347',textTransform:'uppercase'}}>
					{currentPlan.name} PLAN
				  </span>
				</h6> : null}
			  <hr/>
			  <div className="plan-features">
				{appFeatures.map(function(feature, idx){
				  var pid = planState && planState.id ? planState.id : (currentPlan ? currentPlan.id : '');
				  if (pid && feature.plans.indexOf(pid) >= 0) {
					return (
					  <p key={idx} className="pricing-card__feature">
						<CheckIcon size={16} color="#780F9E" style={{marginTop:-3}} /> {feature.name}
						{feature.badge ? <Badge className="sidebar__link-badge"><span>{feature.badge}</span></Badge> : null}
					  </p>
					);
				  } else {
					if (feature.hide && pid && feature.hide.indexOf(pid) >= 0) { return null; }
					return (
					  <p key={idx} className="pricing-card__feature pricing-card__feature--inactive">
						<CircleIcon size={16} style={{marginTop:-3}} /> {feature.name}
					  </p>
					);
				  }
				})}
			  </div>
			  <hr/>
			  {currentPlan && !currentPlan.hideChangePlan ?
				<Link to="/pricing" style={{color:'#9600BF', textAlign:'right'}}>
				  <ChangeIcon size={16} style={{marginTop:-2}} /> Change Plan
				</Link> : null}
			</div>
		  </Col>
		</Row>

		<Footer />
	  </div>
	);
  }
}

export default connect(function(state){ return { plan: state.plan }; })(
  withRouter(WithTracker(SignUp))
);
